import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01b42844"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-selectors" }
const _hoisted_2 = { class: "app-search" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Show blacklisted channels ")
const _hoisted_4 = {
  key: 0,
  class: "cards-view"
}

import {
  ref, reactive, onMounted, watch,
} from 'vue';
import { useRoute } from 'vue-router';

import { useAuth0 } from '@auth0/auth0-vue';
import jwtDecode from 'jwt-decode';

import { IVideo } from '@/types/YoutubeApi';

import AppLayout from '@/components/layout/AppLayout.vue';
import AppHero from '@/components/ui/AppHero.vue';
import AppYoutubeVideoCard from '@/components/AppYoutubeVideoCard.vue';

import YoutubeVideoService, { GetVideosRequest } from '@/services/YoutubeVideoService';

// Authentication

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const token = ref<string | null>(null);
const permissions = ref<string[] | null>(null);

// App
const language = ref<string>('');

const youtubeVideos = ref<IVideo[]>([]);

const calendar = reactive({
  minDate: new Date('2021-12-06'),
  maxDate: new Date(),
});

const selectedDateRange = ref<string[]>([]);

const showBlacklisted = ref<boolean>(false);

const searchTitle = ref<string>('');

const getVideos = async () => {
  if (!selectedDateRange.value.length && !searchTitle.value.length) {
    return;
  }

  // @ts-ignore
  const afterDate = selectedDateRange.value ? selectedDateRange.value[0] : undefined;
  // @ts-ignore
  const beforeDate = selectedDateRange.value ? selectedDateRange.value[1] : undefined;

  const request: GetVideosRequest = {
    language: language.value,
    afterDate,
    beforeDate,
    blacklisted: !showBlacklisted.value,
    title: searchTitle.value.length ? searchTitle.value : undefined,
  };

  const retrievedVideos = await YoutubeVideoService.getVideos(request);

  if (retrievedVideos) {
    youtubeVideos.value = retrievedVideos;
  }
};

const onResetCalendarClick = () => {
  selectedDateRange.value = [];
};

const syncVideos = async () => {
  youtubeVideos.value = [];
  await getVideos();
};

watch(searchTitle, async () => {
  await syncVideos();
});

watch(selectedDateRange, async () => {
  await syncVideos();
});

watch(showBlacklisted, async () => {
  await syncVideos();
});

onMounted(async () => {
  const route = useRoute();

  const languageParam = route.params.language;
  if (typeof languageParam === 'string') {
    language.value = languageParam;
  }

  const accessToken = await useAuth0().getAccessTokenSilently();
  if (accessToken) {
    token.value = accessToken;
    const decodedToken = jwtDecode(accessToken);

    // @ts-ignore
    permissions.value = decodedToken.permissions ?? null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_datepicker = _resolveComponent("o-datepicker")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_tooltip = _resolveComponent("o-tooltip")!
  const _component_o_switch = _resolveComponent("o-switch")!

  return (_openBlock(), _createBlock(AppLayout, null, {
    default: _withCtx(() => [
      _createVNode(AppHero, { title: "Youtube videos" }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_o_field, null, {
            default: _withCtx(() => [
              _createVNode(_component_o_input, {
                modelValue: searchTitle.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTitle).value = $event)),
                placeholder: "Search title"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_o_datepicker, {
          modelValue: selectedDateRange.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDateRange).value = $event)),
          range: "",
          "min-date": _unref(calendar).minDate,
          "max-date": _unref(calendar).maxDate,
          icon: "calendar",
          placeholder: "Click to select..."
        }, null, 8, ["modelValue", "min-date", "max-date"]),
        _createVNode(_component_o_tooltip, { label: "Reset calendar" }, {
          default: _withCtx(() => [
            _createElementVNode("a", { onClick: onResetCalendarClick }, [
              _createVNode(_component_o_icon, {
                icon: "calendar-refresh",
                size: "is-medium"
              })
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_o_field, null, {
        default: _withCtx(() => [
          _createVNode(_component_o_switch, {
            modelValue: showBlacklisted.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showBlacklisted).value = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      (youtubeVideos.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(youtubeVideos.value, (video) => {
              return (_openBlock(), _createBlock(AppYoutubeVideoCard, {
                key: video._id,
                video: video,
                token: token.value,
                permissions: permissions.value,
                lazy: ""
              }, null, 8, ["video", "token", "permissions"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})